// extracted by mini-css-extract-plugin
module.exports = {"Ratio":"styles_Ratio__TO0ca","ratioContainer":"styles_ratioContainer__DvrF1","children":"styles_children__4EYnz"};